import axios from 'axios';

// 创建 axios 实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://api.765.info',
  withCredentials: true, // 允许跨域请求携带 cookie
});

// 初始化 CSRF 令牌
let csrfToken = null;

// 获取 CSRF 令牌的函数
const fetchCsrfToken = async () => {
  try {
    // 发送 GET 请求到后端获取 CSRF 令牌
    const response = await api.get('/api/csrf-token');
    if (response.data && response.data.csrfToken) {
      csrfToken = response.data.csrfToken;
      console.log('CSRF 令牌已获取');
    }
  } catch (error) {
    console.error('获取 CSRF 令牌失败:', error);
  }
};

// 请求拦截器 - 添加 CSRF 令牌到请求头
api.interceptors.request.use(
  async (config) => {
    // 如果是修改数据的请求（POST, PUT, DELETE 等）并且没有 CSRF 令牌，先获取令牌
    if (['post', 'put', 'delete'].includes(config.method.toLowerCase()) && !csrfToken) {
      await fetchCsrfToken();
    }
    
    // 如果有 CSRF 令牌，添加到请求头
    if (csrfToken) {
      config.headers['x-csrf-token'] = csrfToken;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理 CSRF 令牌过期等情况
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // 如果是 CSRF 令牌验证失败（403 错误），刷新令牌并重试一次
    if (error.response && error.response.status === 403 &&
        error.response.data && (error.response.data.message || '').toLowerCase().includes('csrf')) {
      // 防止无限重试
      if (!error.config._retry) {
        error.config._retry = true;
        // 清除旧的令牌
        csrfToken = null;
        // 重新获取令牌
        await fetchCsrfToken();
        // 重试原始请求
        if (csrfToken) {
          error.config.headers['x-csrf-token'] = csrfToken;
          return api(error.config);
        }
      }
    }
    
    return Promise.reject(error);
  }
);

// 初始化时获取一次 CSRF 令牌
fetchCsrfToken();

export default api;